module.exports = __webpack_public_path__ + "assets/img/title-ab03ac08.png";